import Vue from "vue";
import store from "./store";
import Router from "vue-router";
import Home from "./views/Home.vue";
import KioskList from "./views/KioskList.vue";
import Initialize from "./views/Initialize.vue";
import PhotoGallery from "./views/PhotoGallery.vue";
import Community from "./views/Community.vue";
import AvailableHomes from "./views/AvailableHomes.vue";
import LegacyHomes from "./views/LegacyHomes.vue";
import Lots from "./views/Lots.vue";
import NewHomes from "./views/NewHomes.vue";
import BuildHomes from "./views/BuildHomes.vue";
import Calendar from "./views/Calendar.vue";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/initialize/:id/:client_id",
      name: "Mobile",
      component: Initialize,
    },
    {
      path: "/:client_slug/:kiosk_slug/",
      name: "Kiosk Initializer",
      component: KioskList,
    },
    {
      path: "/photogallery",
      name: "Photo Gallery",
      component: PhotoGallery,
    },
    {
      path: "/community",
      name: "Community",
      component: Community,
    },
    {
      path: "/calendar",
      name: "Calendar",
      component: Calendar,
    },
    {
      path: "/available-homes",
      name: "Homes & Lots",
      component: AvailableHomes,
    },
    {
      path: "/legacyhomes",
      name: "Legacy Homes",
      component: LegacyHomes,
    },
    {
      path: "/build",
      name: "Build Homes",
      component: BuildHomes,
    },
    {
      path: "/lots",
      name: "Lots",
      component: Lots,
    },
    {
      path: "/newhomes",
      name: "New Homes",
      component: NewHomes,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (
    to.name == "Mobile" ||
    to.name == "Kiosk Initializer" ||
    store.state.kiosk ||
    to.name == "Text"
  ) {
    next();
  } else {
    next("/null/null");
  }
});

export default router;
